import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { useEffect, useRef, useState } from 'react';


export interface PasswordInputProps {
    value: string;
    placeHolder: string;
    onChange: (val: string) => void;
    invalid?: boolean;
    errorText?: string;
}

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
    const [visible, setVisible] = useState(false);
    const [onFocus, setOnFocus] = useState(false);
    const divRef = useRef<HTMLDivElement>(null);

    const handleInputChange = (val: string) => {
        props.onChange(val);
    }

    // Close dropdown when clicking outside or when page loses focus
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (divRef.current && !divRef.current.contains(event.target as Node)) {
        setOnFocus(false);
      }
    };

    const handleBlurOutside = () => {
        setOnFocus(false);
    };

        // TODO: add moving up and down with the mouse in the dropdown selection

        document.addEventListener('mousedown', handleClickOutside);
        window.addEventListener('blur', handleBlurOutside);

        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        window.removeEventListener('blur', handleBlurOutside);
        };
    }, []);

    return (
        <div>
        <div className={`w-full ${props.invalid ? "border-red-500" : "border-gray-500"} outline-none rounded-xl shadow-main flex row `} ref={divRef}>
            <input
              type={visible ? "text" : "password"}
              placeholder={props.placeHolder}
              name='password'
              autoComplete='current-password'
              value={props.value}
              onChange={(e) => handleInputChange(e.target.value)}
              onFocus={() => {console.log("here focus"); setOnFocus(true)}}
              className="w-full px-3 py-2 bg-transparent border-none select-none focus:outline-none focus:ring-0"
            />
            <div className="pl-1 pr-1 cursor-pointer flex items-center">
                {
                    visible ?
                    <VisibilityOffOutlinedIcon style={{width: '22px', height: '22px'}} onClick={(e) => setVisible(!visible)}/>
                    :
                    <VisibilityOutlinedIcon style={{width: '22px', height: '22px'}} onClick={(e) => setVisible(!visible)}/>
                }
            </div>
        </div>
        {
            props.invalid &&
            <div className="text-red-500 mt-[-4px] text-sm top-[100%] text-start pt-1">{props.errorText}</div>
        }
        </div>
    )
}
